import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function TablePager({ page, pageCount, total, shown, onChange, testId = "pager" }) {
  if (total === 0) return null;
  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-border" data-testid={testId}>
      <p className="text-xs text-muted-foreground">
        Showing <span className="font-medium text-foreground">{shown}</span> of{" "}
        <span className="font-medium text-foreground">{total}</span>
      </p>
      {pageCount > 1 && (
        <div className="flex items-center gap-2">
          <Button variant="outline" size="icon" className="h-8 w-8 rounded-sm" disabled={page <= 1}
            onClick={() => onChange(page - 1)} data-testid={`${testId}-prev`}>
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <span className="text-xs text-muted-foreground tabular-nums" data-testid={`${testId}-label`}>
            Page {page} / {pageCount}
          </span>
          <Button variant="outline" size="icon" className="h-8 w-8 rounded-sm" disabled={page >= pageCount}
            onClick={() => onChange(page + 1)} data-testid={`${testId}-next`}>
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
}
